<template>
  <div class="liquor-word">
    <Header active="/liquor/dana" />

    <HeaderSelect active="dana" :list="headerSelectArray" />

    <div class="container">
      <div
        class="word"
        v-for="(item, index) in wordList"
        :key="index"
        :style="index % 5 === 4 ? 'margin-right: 0' : ''"
        @mousemove="e => onMouseOver(index, e)"
        @mouseout="e => onMouseOver(-1, e)"
        @click="onOpen(index)"
      >
        <svg preserveAspectRatio="xMidYMid slice" viewBox="0 0 212 100">
          <defs>
            <clipPath :id="`clip-${index}`">
              <circle :cx="x" :cy="y" r="100px" />
            </clipPath>
          </defs>
          <text class="cn" x="106" y="45" style="text-anchor: middle">{{item.word}}</text>
          <text class="en" x="106" y="75" style="text-anchor: middle">{{item.wordEn}}</text>
          <g :clip-path="`url(#clip-${index})`">
            <image
              height="100%"
              preserveAspectRatio="xMinYMin slice"
              width="100%"
              :xlink:href="util.getFirstImage(item.images, '212x100')"
            />
            <text class="paraphrase" x="0" y="0">
              <tspan x="8" y="18">{{item.tspans[0]}}</tspan>
              <tspan x="8" y="42">{{item.tspans[1]}}</tspan>
              <tspan x="8" y="66">{{item.tspans[2]}}</tspan>
              <tspan x="8" y="90">{{item.tspans[3]}}</tspan>
            </text>
          </g>
        </svg>
      </div>
      <div class="word-preview" v-if="showWordPreview" @mousewheel.prevent="onMouseWheel">
        <div class="mask" @click="onClose"></div>
        <div class="close" @click="onClose">
          <i class="el-icon-close" />
        </div>
        <div class="arrow-left" @click="onPrev">
          <i class="el-icon-arrow-left" />
        </div>
        <div class="arrow-right" @click="onNext">
          <i class="el-icon-arrow-right" />
        </div>
        <div class="slide-list">
          <div class="slide">
            <img :src="util.getFirstImage(wordList[current].images, '700x330')" />
            <div class="text">
              <div class="cn">{{wordList[current].word}}</div>
              <div class="en">{{wordList[current].wordEn}}</div>
              <div class="paraphrase">{{wordList[current].paraphrase}}</div>
            </div>
          </div>
          <div class="slide slide-1"></div>
          <div class="slide slide-2"></div>
          <div class="slide slide-3"></div>
        </div>
      </div>
    </div>
    <Sticky ref="sticky" />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import Sticky from "@/components/liquor/Sticky";

export default {
  name: "LiquorWord",
  components: {
    Header,
    Sticky,
    HeaderSelect
  },
  data() {
    return {
      showWordPreview: false,
      wordList: [],
      current: 0,
      x: 0,
      y: 0,
      headerSelectArray: [
        {
          name: "专业词汇",
          link: "/liquor/dana",
          active: true
        },
        {
          name: "知识挑战",
          link: "/liquor/game",
          active: false
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorWord",
        methodName: "retrieve",
        params: {
          numPerPage: 1000
        }
      });

      const images = response.results
        .filter(e => e.images)
        .map(e => e.images.split(","))
        .flat();

      this.wordList = response.results.map((e, index) => {
        return {
          ...e,
          images: e.images ? e.images : images[index % images.length],
          tspans: this.getTspans(e.paraphrase)
        };
      });

      console.log(this.$route.query.id);

      const id = this.$route.query.id;

      if (id) {
        console.log(this.wordList);
        const index = this.wordList.findIndex(e => e.id == id);
        if (index) {
          console.log(index);
          this.onOpen(index);
        }
      }
    },
    getTspans(text) {
      let tspans = [];

      for (let index = 0; index < 4; index++) {
        const tspan = text.slice(index * 14, index * 14 + 14);
        tspans.push(tspan);
      }

      return tspans;
    },
    onMouseOver(index, e) {
      if (!this.showWordPreview) {
        this.current = index;

        this.x = e.offsetX;
        this.y = e.offsetY;
      }
    },
    // 什么也不干，只为阻止页面可滑动
    onMouseWheel(e) {
      //   console.log(e);
    },
    onOpen(index) {
      this.current = index;
      this.showWordPreview = true;
      this.$refs["sticky"].onClick();
    },
    onClose() {
      this.showWordPreview = false;
    },
    onPrev() {
      if (this.current > 0) {
        this.current -= 1;
        this.util.animateCSS(
          ".word-preview .slide-list .slide",
          "rotateInUpLeft faster"
        );

        // this.util.animateCSS(
        //   ".word-preview .slide-list .slide .text",
        //   "jackInTheBox"
        // );
      }
    },
    onNext() {
      if (this.current < this.wordList.length - 1) {
        this.util.animateCSS(
          ".word-preview .slide-list .slide",
          "rotateOutUpRight faster",
          () => {
            this.current += 1;
          }
        );

        // this.util.animateCSS(
        //   ".word-preview .slide-list .slide .text",
        //   "jackInTheBox"
        // );
      }
    }
  }
};
</script>

<style lang="scss">
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.liquor-word {
  width: 100%;
  margin: 180px 0;

  .container {
    width: 1100px;
    margin: 0 auto;
    position: relative;

    .word-preview {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      .close,
      .arrow-left,
      .arrow-right {
        z-index: 1000;
        position: absolute;
        width: 44px;
        height: 44px;
        background: rgba(0, 0, 0, 1);
        border-radius: 22px;

        display: flex;
        justify-content: center;
        align-items: center;
        color: #ccc;
        font-size: 20px;
        cursor: pointer;
      }

      .close:hover,
      .arrow-left:hover,
      .arrow-right:hover {
        color: white;
        box-shadow: 0px 10px 21px 0px rgba(0, 0, 0, 0.06);
      }

      .close {
        top: 0;
        right: 0;
      }

      .arrow-left {
        top: calc(400px - 22px);
        left: 0;
      }

      .arrow-right {
        top: calc(400px - 22px);
        right: 0;
      }

      .slide-list {
        z-index: 1000;
        position: absolute;
        width: 700px;
        height: 330px;
        top: calc(400px - 165px);
        left: calc(550px - 350px);

        // background: rgba(0, 0, 0, 0.65);

        .slide {
          width: 700px;
          height: 330px;
          position: absolute;
          background: white;

          //   transform: rotate(45deg);
          //   transform-origin: 20% 40%;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 700px;
            height: 330px;
          }

          .text {
            position: absolute;
            top: 0;
            left: 0;
            padding: 60px;
            width: 580px;
            height: 210px;
            z-index: 2;
            background: rgba(0, 0, 0, 0.65);
          }

          .cn {
            font-size: 40px;
            font-family: "FZQKBYSJW";
            font-weight: normal;
            color: rgba(255, 255, 255, 1);

            z-index: 2;
          }

          .en {
            margin-top: 5px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            z-index: 2;
          }

          .paraphrase {
            margin-top: 36px;
            font-size: 20px;
            font-family: "FZQKBYSJW";
            font-weight: normal;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
            z-index: 2;
          }
        }

        .slide-1 {
          transform: scale(0.96);
          top: 20px;
          z-index: -1;
          opacity: 0.9;
        }
        .slide-2 {
          transform: scale(0.93);
          top: 35px;
          z-index: -2;
          opacity: 0.6;
        }
        .slide-3 {
          transform: scale(0.9);
          top: 50px;
          z-index: -3;
          opacity: 0.3;
        }
      }
    }

    .word {
      display: inline-block;
      margin: 0 10px 10px 0;
      width: 212px;
      height: 100px;
      background: rgba(248, 244, 236, 1);
      text-align: center;
      vertical-align: top;

      display: inline-flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;

      cursor: pointer;

      .cn {
        font-size: 24px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(0, 0, 0, 1);
      }

      .en {
        width: 100%;
        font-size: 18px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }

      position: relative;
      img {
        position: absolute;
        display: none;

        // background: rgba(0, 0, 0, 0.65);
      }

      .paraphrase {
        font-size: 14px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(255, 255, 255, 1);

        fill: white;

        // background: rgba(0, 0, 0, 0.65);
      }

      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        // background: rgba(0, 0, 0, 0.65);

        image {
          //   background: rgba(0, 0, 0, 0.65);
        }
      }

      circle {
        transform: scale(0);
        transition: transform 0.3s;
        transform-origin: 50% 50%;
      }
    }

    .word:hover circle {
      transform: scale(1);
    }
  }
}
</style>